/**
 * Katalog App Route Definitions
 * Single source of truth for app routes.
 *
 * Public entity path shapes are imported from the shared canonical registry.
 * Current live BrandStore routes remain /brand/:handle[/:slug]; legacy
 * /store/:slug and /:handle/store routes redirect to that canonical surface.
 *
 * FORBIDDEN (removed): /stores, /katalogs, /katalog/:slug
 */
import {
  CANONICAL_PUBLIC_ROUTE_REGISTRY,
  LEGACY_PUBLIC_ROUTE_REGISTRY,
} from '@bright-web-skeleton/shared/routing';

export const ROUTES = {
  // Public (SEO-indexed)
  HOME: '/',
  LANDING: '/landing',
  AUTH: '/auth',
  AUTH_CALLBACK: '/auth/callback',

  // Canonical public entity routes
  BRAND_STORE: CANONICAL_PUBLIC_ROUTE_REGISTRY.brandStore.pattern,
  BRAND_CHILD_STORE: CANONICAL_PUBLIC_ROUTE_REGISTRY.brandChildStore.pattern,
  HANDLE_CATALOG_DEAL: '/:handle/:slug/deal/:dealId',
  HANDLE_DEAL: '/:handle/deals/:dealId',
  HANDLE_CATALOG: CANONICAL_PUBLIC_ROUTE_REGISTRY.subKatalag.pattern,
  HANDLE_HUB: CANONICAL_PUBLIC_ROUTE_REGISTRY.katalag.pattern,

  // Legacy redirects
  STORE_LEGACY: LEGACY_PUBLIC_ROUTE_REGISTRY.storeBySlug.pattern,
  HANDLE_STORE_LEGACY: LEGACY_PUBLIC_ROUTE_REGISTRY.handleStore.pattern,

  // Parameterized public routes
  PROFILE: '/profile/:id',

  // Onboarding (protected, no onboarding required)
  ONBOARDING: '/onboarding',

  // Utility / dev
  SIMPLE_TEST: '/simple-test',
  DEMO_TEMPLATE: '/demo-template',
  TOKEN_CHECKER: '/token-checker',
  TAILWIND_SANITY: '/tailwind-sanity',
} as const;

/**
 * Authenticated customer app routes
 */
export const routes = {
  landing: '/',
  auth: '/auth',
  onboarding: '/onboarding',

  // Main app routes (customer-side)
  app: {
    home: '/home',
    discover: '/discover',
    create: '/create',
    wishlist: '/wishlist',
    cart: '/cart',
    stash: '/stash',
    notifications: '/notifications',
    dealDetail: '/deal/:dealId',
    orderConfirmation: '/order-confirmation',
  },

  // Account section
  account: {
    overview: '/account',
    orders: '/account/orders',
    orderDetail: '/account/orders/:orderId',
    addresses: '/account/addresses',
    profile: '/account/profile',
    security: '/account/security',
    preferences: '/account/preferences',
  },
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
